import { render, staticRenderFns } from "./ViewAsSessionAlert.vue?vue&type=template&id=40b53794&scoped=true"
import script from "./ViewAsSessionAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAsSessionAlert.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ViewAsSessionAlert.vue?vue&type=style&index=0&id=40b53794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b53794",
  null
  
)

export default component.exports